import { jsx as _jsx } from "react/jsx-runtime";
import { Hero } from "@components/Pages/Hiring/Hero";
import { Layout } from "@components/Layout/Layout";
import { format } from "date-fns";
export default function Home(param) {
    let { jobPost  } = param;
    return /*#__PURE__*/ _jsx(Layout, {
        pageTitle: "Hire top Javascript Developers in ".concat(format(new Date(), "LLLL yyyy")),
        metaDescription: "Hire best JavaScript developers from all over the World.",
        bodyCN: "px-4",
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-4xl m-auto",
            children: /*#__PURE__*/ _jsx("div", {
                className: "pt-10 pb-20",
                children: /*#__PURE__*/ _jsx(Hero, {})
            })
        })
    });
}
